"use client";

import { useEffect, useState } from "react";
import { ru } from "@/content/ru";

/**
 * Простой сплэш загрузки: показывается, пока страница не загрузилась
 * полностью (load + небольшой «доводчик»). Плавно исчезает, не мешая
 * взаимодействию (pointer-events отключены, после скрытия — не рендерится).
 */
export function LoadingSplash({ logo }: { logo: string }) {
  const [hidden, setHidden] = useState(false);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    let done = false;
    function finish() {
      if (done) return;
      done = true;
      // Небольшая задержка, чтобы анимация не мелькала
      window.setTimeout(() => setHidden(true), 350);
      window.setTimeout(() => setGone(true), 900);
    }

    if (document.readyState === "complete") finish();
    else window.addEventListener("load", finish, { once: true });

    // Страховка: не держим сплэш дольше 3 секунд
    const safety = window.setTimeout(finish, 3000);

    return () => {
      window.removeEventListener("load", finish);
      window.clearTimeout(safety);
    };
  }, []);

  if (gone) return null;

  return (
    <div
      aria-hidden
      className={`pointer-events-none fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background transition-opacity duration-500 ${
        hidden ? "opacity-0" : "opacity-100"
      }`}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={logo} alt="" width={64} height={64} className="rounded-xl" />
      <div className="mt-5 h-1 w-40 overflow-hidden rounded-full bg-muted">
        <span className="block h-full w-1/3 animate-[splash_1.1s_ease-in-out_infinite] rounded-full bg-primary" />
      </div>
      <p className="mt-3 text-xs text-muted-foreground">{ru.ui.loading.label}</p>
      <style>{`@keyframes splash { 0% { transform: translateX(-120%); } 100% { transform: translateX(320%); } }`}</style>
    </div>
  );
}
